import { render, staticRenderFns } from "./container.vue?vue&type=template&id=2b44a00a&"
import script from "./container.vue?vue&type=script&lang=ts&"
export * from "./container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b44a00a')) {
      api.createRecord('2b44a00a', component.options)
    } else {
      api.reload('2b44a00a', component.options)
    }
    module.hot.accept("./container.vue?vue&type=template&id=2b44a00a&", function () {
      api.rerender('2b44a00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/container.vue"
export default component.exports